import { defineComponent } from "vue";
export default defineComponent({
  name: "LogisticsMeet",
  setup() {
    const themeVars = {
      primaryColor: "linear-gradient(24deg, #5282F0, #608DF4)",
      buttonPrimaryBackground: "linear-gradient(24deg, #5282F0, #608DF4)",
      buttonPrimaryBorderColor: "linear-gradient(24deg, #5282F0, #608DF4)"
    };
    return {
      themeVars
    };
  }
});